export const paths = {
  error: "/400",
  home: "/",
  notFound: "/404",
  repository: "https://github.com/wmalarski/solid-trails",
  signIn: "/sign-in",
};
